import getTagValue from "./get-tag-value";
import isEndpointSoldOut from "./is-endpoint-sold-out";

const getRank = (endpoint) => {
    const rank = parseFloat(getTagValue(endpoint.tags, 'rank', ':'));
    return isNaN(rank) ? Infinity : rank;
};

// null when the endpoint is not pinned, or its pinIndex tag is not a number
const getPinIndex = (endpoint) => {
    const pinIndex = parseInt(getTagValue(endpoint.tags, 'pinIndex', ':'));
    return isNaN(pinIndex) ? null : pinIndex;
};

const getPinTime = (endpoint) => {
    const pinTime = new Date(getTagValue(endpoint.tags, 'pinTime', ':')).getTime();
    return isNaN(pinTime) ? 0 : pinTime;
};

const sortByRank = (endpoints) => {
    const sorted = [];
    const pinned = [];
    endpoints.forEach(e => (getPinIndex(e) === null ? sorted : pinned).push(e));
    sorted.sort((a, b) => getRank(a) - getRank(b));
    // ascending pinIndex, so every endpoint is inserted at the index it asks for
    // and is no longer shifted by a pin placed above it afterwards;
    // when two endpoints claim the same index, the most recently pinned one wins it
    pinned.sort((a, b) => getPinIndex(a) - getPinIndex(b) || getPinTime(a) - getPinTime(b));
    pinned.forEach(element => {
        sorted.splice(getPinIndex(element), 0, element);
    });
    return sorted;
};

export const sortShopFront = (endpoints) => {
    const available = [];
    const soldOut = [];
    // rank and pinning are resolved across the whole list first, so the order the
    // merchant configured is the one that applies; sold out endpoints are only
    // lifted out afterwards and the rest keeps its relative order
    sortByRank(endpoints).forEach(e => (isEndpointSoldOut(e) ? soldOut : available).push(e));
    return [...available, ...soldOut];
};
